import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

interface Props {
  productKey: string;
  planId?: number;
}
export const useProductSubscription = ({ productKey, planId }: Props) => {
  const { data, error, loading } = useQuery<
    GetProductSubscriptionsQuery,
    GetProductSubscriptionsQueryVariables
  >(GET_PRODUCT_SUBSCRIPTIONS, {
    variables: { planId: planId || -1 },
    skip: !planId,
  });

  const productSubscriptions = data?.plan.productSubscriptions || [];
  const result = productSubscriptions.find(
    productSubscription => productSubscription.product?.key === productKey
  );

  return { data: result, error, loading };
};

export const GET_PRODUCT_SUBSCRIPTIONS = gql`
  query GetProductSubscriptions($planId: Int!) {
    plan(id: $planId) {
      id
      productSubscriptions {
        id
        createdAt
        amountCents
        details
        product {
          id
          key
          name
        }
        status
      }
    }
  }
`;

export const getProductSubscriptionsMock = {
  plan: {
    __typename: 'Plan',
    id: 20,
    productSubscriptions: [
      {
        amountCents: '500',
        createdAt: '2021-01-01',
        details: {},
        id: 11,
        product: {
          id: 111,
          key: '500_cent_membership',
          name: 'Membership',
        },
        status: 'active',
      },
      {
        amountCents: 0,
        createdAt: '2021-01-01',
        details: {},
        id: 22,
        product: { id: 222, key: 'bill_pay_service', name: 'Bill Pay' },
        status: 'active',
      },
      {
        amountCents: '500',
        createdAt: '2021-02-01',
        details: {},
        id: 33,
        product: {
          id: 333,
          key: 'national_solar',
          name: 'National Solar Patronage',
        },
        status: 'active',
      },
    ],
  },
};

export const useProductSubscriptionMock = productKey => {
  const data = getProductSubscriptionsMock.plan.productSubscriptions.find(
    subscription => subscription.product.key === productKey
  );
  return { data, error: undefined, loading: false };
};
